// ==== AWS ======
export const BASEURL = "https://backend.apiitsotuc2021.com/api/";
// ==== LOCAL ====
// export const BASEURL = "http://192.168.1.134:3001/api/";
// export const BASEURL = "http://localhost:3001/api/";
